import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import { action, set } from '@ember/object';
import Component from '@glimmer/component';
import EmberTooltip from '@mylighthouse/prism-ember/components/ember-tooltip';

interface SettingsReportsTablesCellsTdScheduledBySignature {
  Args: {
    cellData: unknown;
  };
}

export default class SettingsReportsTablesCellsTdScheduledBy extends Component<SettingsReportsTablesCellsTdScheduledBySignature> {
  isHovered = false;

  @action
  // @ts-expect-error: Incorrect type
  isCellHovered(isHovered): void {
    set(this, 'isHovered', isHovered);
  }

  <template>
    <div
      class="truncate"
      role="tooltip"
      {{on "mouseenter" (fn this.isCellHovered true)}}
      {{on "mouseleave" (fn this.isCellHovered false)}}
    >
      {{! @glint-expect-error: Incorrect type }}
      {{@cellData}}
    </div>
    {{#if this.isHovered}}
      <EmberTooltip
        @isShown={{this.isHovered}}
        @tooltipClass="default-tooltip default-tooltip--large"
      >
        {{! @glint-expect-error: Incorrect type }}
        {{@cellData}}
      </EmberTooltip>
    {{/if}}
  </template>
}
